import CRUD from './CRUD';

/**
 * Provides a set of CRUD operations around API: /project.
 */
export default class ProjectClient extends CRUD {
	constructor() {
		super('/project/summary');
	}
}

